export const flowAdmissionTicketZH = {
  flowAdmissionTicket1: '下载',
  flowAdmissionTicket2: '暂无准考证信息',
  flowAdmissionTicket3: '准考证',
  flowAdmissionTicket4: '准考证文件正在生成中... 请稍后下载',
  flowAdmissionTicket5: '完成前置任务后方可解锁当前任务',
  flowAdmissionTicket6: '拼命下载中……',
  flowAdmissionTicket7: '页面渲染出错,请联系bloom客服',
  flowAdmissionTicket8: '内容一个页面1',
  flowAdmissionTicket9: '内容已超过俩个页面高度',
  flowAdmissionTicket10: '页面元素高度大于一个页面，无法显示,请联系bloom团队处理',
  flowAdmissionTicket11: '正在下载中……  请勿重复下载',
  flowAdmissionTicket12: '亲爱的同学，你的准考证已生成，请于当天出示电子版或打印版准考证入场。准考证文件可以登录BloomPC端进行下载。',
  flowAdmissionTicket13: '你的准考证还未生成，请联系组委会！',
  flowAdmissionTicket14: '亲爱的同学，你的',
  flowAdmissionTicket15: '中文姓名',
  flowAdmissionTicket16: '英文姓名',
  flowAdmissionTicket17: '准考证号',
  flowAdmissionTicket18: '组别',
  flowAdmissionTicket19: '考场信息',
  flowAdmissionTicket20: '考场',
  flowAdmissionTicket21: '考试时间',
  flowAdmissionTicket22: '考试地址',
  flowAdmissionTicket23: '紧急联络人',
  flowAdmissionTicket24: '考前须知',
  flowAdmissionTicket25: '准考证已生成，请于',
  flowAdmissionTicket26: '当天出示电子版或打印版准考证入场。准考证文件可以登录Bloom PC端进行下载。'

}

export const flowAdmissionTicketEN = {
  flowAdmissionTicket1: 'Download',
  flowAdmissionTicket2: 'There is no admission card information',
  flowAdmissionTicket3: 'Admission card',
  flowAdmissionTicket4: 'The admission card is being generated... Please download it later',
  flowAdmissionTicket5: 'The current mission can only be unlocked after completing the pre-task',
  flowAdmissionTicket6: 'Downloading......',
  flowAdmissionTicket7: 'If there is a page rendering error, please contact Bloom customer service',
  flowAdmissionTicket8: 'Contents of a page 1',
  flowAdmissionTicket9: 'The content has exceeded two page heights',
  flowAdmissionTicket10: 'If the height of the page element exceeds one page and cannot be displayed, please contact the bloom team to deal with it',
  flowAdmissionTicket11: 'Downloading......  Do not download repeatedly',
  flowAdmissionTicket12: 'Dear students, your admission card has been generated. Please present the electronic or printed version of the admission card on the day. The admission ticket can be downloaded from BloomPC.',
  flowAdmissionTicket13: 'Your admission card has not been generated yet, please contact the organizing committee! ',
  flowAdmissionTicket14: 'Dear students, your ',
  flowAdmissionTicket15: 'Chinese name',
  flowAdmissionTicket16: 'English name',
  flowAdmissionTicket17: 'Admission ticket number',
  flowAdmissionTicket18: 'Group',
  flowAdmissionTicket19: 'Examination room information',
  flowAdmissionTicket20: 'Examination room',
  flowAdmissionTicket21: 'Exam time',
  flowAdmissionTicket22: 'Examination address',
  flowAdmissionTicket23: 'Emergency contact person',
  flowAdmissionTicket24: 'Notes before the examination',
  flowAdmissionTicket25: 'admission card has been generated. Please show your electronic or printed admission card on the same day of ',
  flowAdmissionTicket26: '. The admission card file can be downloaded by logging in to the Bloom PC.'
}



// WEBPACK FOOTER //
// ./src/assets/locale/flow/admissionTicket.js